<script>
const APIServiceURL = 'https://www.searchplusplus.jp'
const port = ''
export default {
  APIServiceURL,
  port
}
</script>
